import type { AxiosResponse } from 'axios'
import ResponseError from './ResponseError'
export default class ResponseErrorSessionException extends ResponseError {
  declare response: AxiosResponse
  declare reponseData: unknown

  constructor(message: string, cause: Error, response: AxiosResponse, reponseData?: unknown) {
    super(message, cause, response)

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    // @ts-ignore
    if (Error.captureStackTrace) {
      // @ts-ignore
      Error.captureStackTrace(this, ResponseErrorSessionException)
    }

    this.name = 'ResponseErrorSessionException'

    // CustomData
    this.response = response
    this.reponseData = reponseData
  }
}
